/* ----------------------------------------
    Vue
---------------------------------------- */

import Vue from 'vue';
import App from '@/App.vue';
import router from '@router/router';
import store from '@store/store';
import FruitPackage from '@fruitpackage';

/* ----------------------------------------
    Vue Configuration
---------------------------------------- */

Vue.config.productionTip = false;
Vue.config.devtools = true;

/* ----------------------------------------
    Vue Plugins
---------------------------------------- */

Vue.use(FruitPackage);

/* ----------------------------------------
    Vue Data
---------------------------------------- */

const env = {
    type: process.env.NODE_ENV,
    baseUrl: process.env.VUE_APP_BASE_URL
};

const path = {
    start: window.location.pathname
};

const log = {
    type: process.env.LOGNAME
};

/* ----------------------------------------
    Vue Mixins
---------------------------------------- */

import './mixins/mixins';

/* ----------------------------------------
    Vue Filters
---------------------------------------- */

import './filters/filters';

/* ----------------------------------------
    Vue Registration
---------------------------------------- */

import './service/Registration';

/* ----------------------------------------
    Vue Directives
---------------------------------------- */

import './directives/outside';

/* ----------------------------------------
    Initiate Vue
---------------------------------------- */

new Vue({
    el: '#app',
    data: {
        path: path,
        env: env,
        log: log,
        public: true,
    },
    router,
    store,
    render: app => app(App)
});

/* ----------------------------------------
    Set Bugherd
---------------------------------------- */

import { Bugherd } from '@helpers/Bugherd';
new Bugherd();